export default class ToolSection {
  constructor(changeTracker, drawingToolKit, selection, colorManager, toolOptionToggler) {
    this._changeTracker = changeTracker;
    this._drawingToolKit = drawingToolKit;
    this._selection = selection
    const elSection = document.querySelector('#toolSection');
    this._elButtons = elSection.querySelectorAll('.toolButton.tool');
    this._elButtonUndo = elSection.querySelector('.toolButton.undo');
    this._elButtonRedo = elSection.querySelector('.toolButton.redo');
    this._elButtonUndoOutput = elSection.querySelector('.toolButton.undo output');
    this._elButtonRedoOutput = elSection.querySelector('.toolButton.redo output');
    const elButtonColorInner = elSection.querySelector('.toolButton.color .inner');
    
    const setMode = e => {
      if(e.target.classList.contains('tool')) {
        this.setMode(e.target.dataset.mode);
        this._selection.finishIfNot();  // TODO: ここが最適なのか検討
      }
    };
    elSection.addEventListener('click', setMode);
    elSection.addEventListener('contextmenu', setMode);
    this._elButtonUndo.addEventListener('click', this.undo.bind(this));
    this._elButtonRedo.addEventListener('click', this.redo.bind(this));
    Array.from(elSection.querySelectorAll('.undoredo'), v => v.addEventListener('animationend', () => {
      v.classList.remove('popup');
    }));
    colorManager.register(color => {
      elButtonColorInner.style.backgroundColor = `rgba(${color.join()})`;
    });
    elSection.addEventListener('mouseleave', () => toolOptionToggler.setClose());
    elSection.addEventListener('mouseenter', () => toolOptionToggler.clearClose());

    // ツールオプションの表示
    elSection.addEventListener('mouseover', e => {
      if(e.target.classList.contains('toolButton') && e.target.classList.contains('mouseoverMenu')) {
        toolOptionToggler.show(e.target, false);
      }
    });
    elSection.addEventListener('contextmenu', e => {
      if(e.target.classList.contains('toolButton') && !e.target.classList.contains('mouseoverMenu')) {
        toolOptionToggler.show(e.target, false);
      }
    });
    elSection.addEventListener('click', e => {
      if(e.target.classList.contains('toolButton') && !e.target.classList.contains('mouseoverMenu')) {
        if(e.target.classList.contains('tool')) {
          toolOptionToggler.close();
        } else {
          toolOptionToggler.show(e.target);
        }
      }
    });
  }
  setMode(mode) {
    this._elButtons.forEach(v => {
      if(mode === v.dataset.mode) {
        v.classList.add('selected');
      } else {
        v.classList.remove('selected');
      }
    });
    this._drawingToolKit.setMode(mode);
  }
  undo() {
    if(0 < this._changeTracker.undoLength) {
      this._changeTracker.undo();
      this._elButtonUndo.classList.add('popup');
      this._elButtonRedo.classList.add('popup');
    }
  }
  redo() {
    if(0 < this._changeTracker.redoLength) {
      this._changeTracker.redo();
      this._elButtonUndo.classList.add('popup');
      this._elButtonRedo.classList.add('popup');
    }
  }
  updateHistoryButtons() {
    this._elButtonUndoOutput.textContent = this._changeTracker.undoLength;
    if(this._changeTracker.undoLength === 0) {
      this._elButtonUndo.classList.add('disabled');
    } else {
      this._elButtonUndo.classList.remove('disabled');
    }
    
    this._elButtonRedoOutput.textContent = this._changeTracker.redoLength;
    if(this._changeTracker.redoLength === 0) {
      this._elButtonRedo.classList.add('disabled');
    } else {
      this._elButtonRedo.classList.remove('disabled');
    }
  }
}
